/* istanbul ignore file */
export enum NotificationHandlerEventType {
  /**
   * triggered when the handler is opened and can receive message
   */
  OPEN = 'open',
  /**
   * triggered when the handler received a message
   */
  MESSAGE = 'message',
  /**
   * triggered when the handler is closed and cannot receive message
   */
  CLOSE = 'close',
  /**
   * triggered when an error is thrown
   */
  ERROR = 'error',
  /**
   * triggered when the websocket connection tries too many attempts
   */
  RESTART_REQUIRED = 'restart-required',
  /**
   * triggered before the websocket lifetime ends
   */
  UPDATE_CHANNEL_LIFETIME = 'update-channel-lifetime',
}

export class NotificationHandlerEvent extends Event {
  constructor(type: NotificationHandlerEventType, eventInitDict?: EventInit) {
    super(type, eventInitDict)
  }
}
